import React from 'react';
import styled from 'styled-components';

import { Stack } from '../../../components/stack/stack';
import { UserList } from '../../../components/user-list/user-list';

const Container = styled(Stack)`
  width: 100%;
`;

const ProjectUsers = () => {
  return (
    <Container direction="column" spacing={1.5}>
      <UserList />
    </Container>
  );
};

export { ProjectUsers };
